import { render, staticRenderFns } from "./loginPrice.vue?vue&type=template&id=2977f5ec&scoped=true&"
import script from "./loginPrice.vue?vue&type=script&lang=js&"
export * from "./loginPrice.vue?vue&type=script&lang=js&"
import style0 from "./loginPrice.vue?vue&type=style&index=0&id=2977f5ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977f5ec",
  null
  
)

export default component.exports